import { __read, __assign } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import { NvSpinner } from '@invitae/ids-react';
import NvVideo from '../NvVideo/NvVideo.esm.js';
import VideoPage from '../VideoPage/VideoPage.esm.js';
import NvVimeo from '../Vimeo/Vimeo.esm.js';

var Video = function (props) {
    var _a = __read(useState(true), 2), isLoading = _a[0], setIsLoading = _a[1];
    var _b = __read(useState(false), 2), isLoadedInVideoPage = _b[0], setIsLoadedInVideoPage = _b[1];
    useEffect(function () {
        var _a;
        if (typeof window !== 'undefined' && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href.includes('/videos'))) {
            setIsLoadedInVideoPage(true);
        }
        setIsLoading(false);
    }, []);
    if (isLoading) {
        return (React__default.createElement("div", null,
            React__default.createElement(NvSpinner, { isLoading: true })));
    }
    if (!isLoading && !isLoadedInVideoPage) {
        return props.vimeoId ? React__default.createElement(NvVimeo, __assign({}, props)) : React__default.createElement(NvVideo, __assign({}, props));
    }
    if (!isLoading && isLoadedInVideoPage) {
        return React__default.createElement(VideoPage, __assign({}, props));
    }
    return null;
};

export { Video as default };
//# sourceMappingURL=Video.esm.js.map
